import useModuleToggle from './useModuleToggle'
import { ToggleButton } from './styled-components'

interface ModuleToggleProps {
  expanded: boolean
  onToggle: () => void
  moduleKey: string
}

const ModuleToggle = ({ expanded, onToggle, moduleKey }: ModuleToggleProps) => {
  const { Icon, label, onClick } = useModuleToggle(expanded, onToggle)

  return (
    <ToggleButton
      type='button'
      id={`toggle-module-${moduleKey}`}
      aria-expanded={expanded}
      aria-label={label}
      title={label}
      onClick={onClick}
    >
      <Icon size={32} />
    </ToggleButton>
  )
}

export default ModuleToggle
